module.exports = __webpack_public_path__ + "static/media/pic8.07ea2dee.jpg";